@import "../../variables.scss";

.minHeight_md_60vh {
  height: auto;
  @media (max-width: $size-md) {
    min-height: 60vh;
  }
}

.minHeight_lg_60vh {
  height: auto;
  @media (max-width: $size-lg) {
    min-height: 60vh;
  }
}

.minHeight_60vh {
  min-height: 60vh;
}

h3 {
  font-size: 1.75rem;
  font-weight: 300;
}

.topDropzone {
  margin-bottom: 3rem;
  @media (max-width: $size-lg) {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
}

.bottomDropzone {
  @media (max-width: $size-lg) {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
}

.hideTopShadowOnMobile {
  @media (max-width: $size-lg) {
    overflow-y: hidden;
    padding: 0 10px 10px 10px;
    margin: 0 -10px;
  }
}

.docsPreview {
  background: rgba(33, 150, 243, 0.1);
  padding: 0.5rem 1rem;
  display: flex;
  align-items: flex-end;

  &__container {
    margin: 0 0.5rem;
    display: flex;
    flex-direction: column;
    justify-content: end;
    position: relative;
    border-radius: 2px;
  }
  &__img {
    width: 100%;
    border-radius: 2px;
    max-width: 140px;
    max-height: 180px;
    object-fit: cover;
  }
  &__sharecode {
    width: 100%;
    border-radius: 2px;
    max-width: 160px;
    height: 100px;
    font-size: medium;
    padding: 20px;
    object-fit: cover;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &__caption {
    width: 100%;
    padding: 0.5rem;
    color: white;
    font-size: 12px;
    letter-spacing: 0.6px;
    position: absolute;
    border-radius: 2px;
    background: rgba(73, 80, 87, 0.9);
    left: 0;
    bottom: 0;
    word-break: break-word;
  }
}

.radius2 {
  border-radius: 2px;
}

// see: hideTopShadowOnMobile
.removeHackPadding {
  @media (max-width: $size-lg) {
    margin-bottom: -10px;
  }
}


.btn_backToMyAccount {
  @media (min-width: $size-sm) {
    min-width: 175px !important;
  }
}

.actions {
  display: flex;
  justify-content: flex-end;
  width: 100%;

  a:hover {
    text-decoration: none;
  }

  button {
    width: 140px;

    &:hover {
      text-decoration: none;
    }
  }
}

.link {
    color: $color-bright-blue;
    text-decoration: underline;
    cursor: pointer;
}